// extracted by mini-css-extract-plugin
export var measureBox = "_aw-0";